// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Settings-Mc2Settings-module__box--YNhDf {
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 880px;
  column-gap: 12px;
  row-gap: 8px;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Settings-Mc2Settings-module__box--YNhDf h3 {
  grid-column: span 2;
  margin-top: 10px;
  margin-bottom: 0;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Settings-Mc2Settings-module__box--YNhDf .src-businessServices-services-bsMeasurementChart2-Mc2Settings-Mc2Settings-module__footer--w2P1r {
  height: 32px;
  grid-column: span 2;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Settings/Mc2Settings.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AACF;AANA;EAQI,mBAAA;EACA,gBAAA;EACA,gBAAA;AACJ;AAXA;EAcI,YAAA;EACA,mBAAA;AAAJ","sourcesContent":[".box {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  max-width: 880px;\n  column-gap: 12px;\n  row-gap: 8px;\n\n  h3 {\n    grid-column: span 2;\n    margin-top: 10px;\n    margin-bottom: 0;\n  }\n\n  .footer {\n    height: 32px;\n    grid-column: span 2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsMeasurementChart2-Mc2Settings-Mc2Settings-module__box--YNhDf`,
	"footer": `src-businessServices-services-bsMeasurementChart2-Mc2Settings-Mc2Settings-module__footer--w2P1r`
};
export default ___CSS_LOADER_EXPORT___;
